<template>
  <ul class="setting">
    <li>
      <div class="item-block">
        <span class="text-title">{{ $ln('遊戲音效') }}</span>
        <label class="switch">
          <input type="checkbox" @input="setSoundOpen" v-model="isSoundOpen" :checked="isSoundOpen" />
          <span class="slider round"></span>
        </label>
      </div>
    </li>
    <li>
      <div class="item-block">
        <span class="text-title">{{ $ln('遊戲音樂') }}</span>
        <label class="switch">
          <input type="checkbox" @input="setMusicOpen" v-model="isMusicOpen" :checked="isMusicOpen" />
          <span class="slider round"></span>
        </label>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'settingSelectList',
  data() {
    return {
      isMusicOpen: true,
      isSoundOpen: true
    }
  },
  created() {
    this.getSessionSettings() // 取得localStorage的設定
    console.log('created this.isMusicOpen', this.isMusicOpen)
    console.log('created this.isSoundOpen', this.isSoundOpen)
  },
  methods: {
    /**
     * 設定音效開關
     */
    setSoundOpen() {
      this.isSoundOpen = !this.isSoundOpen
      localStorage.setItem('isSoundOpen', this.isSoundOpen)
      console.log('isSoundOpen', this.isSoundOpen)
      console.log('localStorage.getItem(\'isSoundOpen\')', localStorage.getItem('isSoundOpen'))
    },
    /**
     * 設定音樂開關
     */
    setMusicOpen() {
      this.isMusicOpen = !this.isMusicOpen
      localStorage.setItem('isMusicOpen', this.isMusicOpen)
      console.log('isMusicOpen', this.isMusicOpen)
      console.log('localStorage.getItem(\'isMusicOpen\')', localStorage.getItem('isMusicOpen'))
    },
    /**
     * 取得localStorage的設定
     */
    getSessionSettings() {
      // 音樂
      this.isMusicOpen = localStorage.getItem('isMusicOpen') !== null ? JSON.parse(localStorage.getItem('isMusicOpen')) : true
      // 音效
      this.isSoundOpen = localStorage.getItem('isSoundOpen') !== null ? JSON.parse(localStorage.getItem('isSoundOpen')) : true
    }
  }
}
</script>

<style scoped></style>
